import { AppState } from '../types';
import { createStatePropSelectorCreator } from '../utils';
import { CanvasState } from './slice';

export const canvasStateSelector = (state: AppState): CanvasState => state.canvas;

export const createCanvasStatePropSelector = createStatePropSelectorCreator<'canvas'>('canvas');
